import { useEffect, useState } from "react";

/**
 * While lazy-loading a view, React.Suspense sets display:none which causes DOM calculations to fail.
 * This function causes a refresh when display: none disappears which fixes the issue.
 */
export function enableDisplayNoneWorkaround() {
  //  TODO: Om uppdaterar React så behövs denna nog inte längre.
  if (!window.MutationObserver) {
    return;
  }

  const root = document.getElementById('main');

  const observer = new window.MutationObserver(() => {
    if (root.children.length < 2) {
      //  Anta att det är en task indicator medan den laddar.
      return;
    }

    if ((root.children[0] as HTMLElement)?.style.display === 'none') {
      return;
    }

    if (document.getElementById('preload')) {
      return;
    }

    const _window = window as typeof window & { onAppLazyLoaded?: () => void; };
    _window.onAppLazyLoaded?.();
    observer.disconnect();
  });

  observer.observe(root, { childList: true });
}

export const useDisplayNoneWorkaround = () => {
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    //  See display_none_workaround.
    const _window = window as typeof window & { onAppLazyLoaded?: () => void; };
    _window.onAppLazyLoaded = () => setNonce(Date.now());
  }, []);
}